import { DEFAULT_COUNTRY } from './constants';

// Set per project in blaze.config:
//
//   config.plugins.set(addressLookup, {
//     apiKey: process.env.BLAZE_LOQATE_API_KEY,
//     defaultCountry: 'GB'
//   });
//
// Without a key the plugin is disabled and AddressLookup renders nothing, so a
// form using it works as it did before.
const defaults = {
  apiKey: '',
  defaultCountry: DEFAULT_COUNTRY,
  enabled: false
};

let config = { ...defaults };

const isValidKey = value => typeof value === 'string' && value.trim().length > 0;
const isValidCountry = value => typeof value === 'string' && /^[A-Za-z]{2}$/.test(value);

export function setPluginConfig(options = {}) {
  const { apiKey, defaultCountry } = options;
  const hasKey = isValidKey(apiKey);

  config = {
    apiKey: hasKey ? apiKey.trim() : defaults.apiKey,
    defaultCountry: isValidCountry(defaultCountry)
      ? defaultCountry.toUpperCase()
      : defaults.defaultCountry,
    enabled: hasKey
  };
  return config;
}

export function getPluginConfig() {
  return config;
}

export function resetPluginConfig() {
  config = { ...defaults };
  return config;
}
